import { Injectable } from '@angular/core';
import { DataProvider, StrapiService } from '../../core';
import { Collectible } from './collectible.model';

import { map } from 'rxjs/operators';

import { MapData } from '@portals/api';
import { DashboardFilterData } from 'libs/portals/store/src/lib/states/collectibles.state';
@Injectable()
export class CollectibleService extends StrapiService<Collectible> {
	protected override model: string = 'collectibles';

	constructor(dataProvider: DataProvider) {
		super(dataProvider);
	}

	postTrustedContacts(contacts: any) {
		return this.dataProvider.post<any>('trustedcontacts', contacts);
	}

	incidentViewer(uuid: any) {
		return this.dataProvider.get<Collectible>(`incident-viewer/${uuid}`);
	}

	momentQuery(notificationID: number) {
		return this.dataProvider.get<any>(`/collectibles/moments/momentsQuery?id=${notificationID}`);
	}
	momentQueryByProject(projectId: number, filter: any) {
		return this.dataProvider.post<any>(`/collectibles/moments/momentsQueryByProject?id=${projectId}`, filter);
	}

	putTranscriptionText(uuid: string, data: any) {
		return this.dataProvider.put<any>(`/collectibles/${uuid}/transcription`, data);
	}
	getFullTranscription(uuid: string) {
		return this.dataProvider.get<any>(`/collectibles/${uuid}/transcription`);
	}
	// /collectibles/filterData
	getFilterData() {
		return this.dataProvider.get<DashboardFilterData>(`/collectibles/filterData`);
	}
	getTrafficChartData(timeframe: string, params: Record<string, string | number | boolean | undefined>, filter: any) {
		return this.dataProvider.post<any>(`/collectibles/traffic-charts/${timeframe}`, filter, { params });
	}
	getTopNotifications(timeframe: string, params: Record<string, string | number | boolean | undefined>, filter: any) {
		return this.dataProvider.post<any>(`/collectibles/top-notification/${timeframe}`, filter, { params });
	}
	getHeatMapData(timeframe: string, params: Record<string, string | number | boolean | undefined>, filter: any) {
		return this.dataProvider.post<any>(`/collectibles/heatmap/${timeframe}`, filter, { params });
	}
	getMapsData() {
		return this.dataProvider.get<MapData[]>(`/collectibles/maps`);
	}
}
